// @ts-nocheck
/**
 * TODO: 
 * 1) Обеспечить стабильную работу функции route, checkRoute ...
 * 2) Проверить расчёты
 */

import {
  a,
  addToCurrentListeners,
  detachAllListeners,
  displayHiddenShapes,
  getashapes,
  getDisplayedShapes,
  getSelectedShapes,
  hideSelectedShapes,
  pushSelected,
  reset,
  resetCpoints,
  resetSelectedShapes,
  resetSelectionStep,
  segCsegs,
  selectAllShapes,
  selectIfMouseInShapeBoundary,
  setashapes,
  setCpoint1,
  setCpoint2,
  setCpointClick,
  setCpointInitAngleDeg,
  setMode,
  getLinesIfSelected,
  assignAend,
} from "../shared/globalState/a";
import { getBranchByElement, printGraphs } from "./graph&network";
import { clearTooltipAll, createInfoTooltip, createTooltipWithInput } from "./tooltip";
import { makeOffset, makeOffsetGuide } from "./transformator";
import { s } from "../shared/globalState/settings";
import { selectedText$, textLinesCollection, textLinesCollection$ } from "../libs/canvas-text/src/shared/state";
import { addShapes, deleteOneShape, deleteShapes, drawShapes, updateAndDrawShapes } from "../shared/render/shapes";
import { rerender } from "../libs/canvas-text/src";
import { cnv } from "../libs/canvas-text/src/shared/cnv";
import { CommandList as cl, CommandList } from "../models/CommandList";
import {
  canvasGetMouse,
  checkFunction,
  findIntersection,
  getFreeShapeRotateMatByMouse,
  getRoute,
  isin,
  isLineHorizontal,
  transformPointByMatrix3,
} from "../shared/common";
import { g } from "../shared/globalState/g";
import { getDpRectAir, getVelocityRect } from "./calculations";
import { t } from "../shared/globalState/t";
import { createIdentityMatrix, resetWebGLMatrices } from "../shared/utils/matrixHelpers";
import { getShapeStart, getShapeEnd, getShapeNet, getShapeRouteId, getShapeCenter, getShapeRadius } from "../shared/utils/shapeFilters";
import {
  clear as dbClear,
  create as dbCreate,
  dbUpdate$,
  saveToBlockCollection
} from "./database";
import { Block } from "../models/shapes/Block";
import {
  connect,
  findConnectedElbows,
  findConnectedLineEnd,
  findConnectedLineStart,
  getPStartPEndProjWhenJoinedBoth,
  getPStartPEndProjWhenJoinedEnd,
  getPStartPEndProjWhenJoinedStart,
  ifjoinedAtEnd,
  ifjoinedAtStart
} from "./joinObserver";
import { Point } from "../models/Point";
import {
  getMirrorMatrix,
  getMoveMatrix,
  getRotateMatrix,
  getScaleMatrix,
  transformPointByMatrixDependingOnShapeType
} from "../shared/transform";
import { mat3 } from "gl-matrix";
import { Vector } from "../models/Vector";

import { arrayFirst, arrayLast } from "../utils/exstensions";
import { findMaxMinPoints } from "../shared/common/clean";
import { ObjectTypes } from "../shared/enums";
import { Line } from "../models/shapes/Line";
import { Rectangle } from "../models/shapes/Rectangle";

import { NetElem, RouteCrucialPoints, Shape, FlowDirection } from "../shared/types";
import { Tee } from "../models/resistances/Tee";
import { ElbowBlock } from "../models/resistances/ElbowBlock";
import { DrawingModes } from "../shared/enums";
import { uid } from "../utils/helpers";
import { getNetworkElementsByNodes } from "./graph&network";
import { Graf } from "../models/nets/GraphExtension";



function handleMakeOffset(event) {
  if (a.blockUI) return;
  if (!getSelectedShapes().length) return;
  setMode("offset");
  // предотвратить передачу символа N в поле ввода
  event.preventDefault();


  let { tooltip, inputField } = createTooltipWithInput(200, 0, s.tooltipBottomOffset);
  // назначить inputField глобальному a, что того, чтобы изменить значение из функции handleMouseMove;
  a.currentInputField = inputField;

  inputField.addEventListener("keyup", function (event) {
    a.userInputValue = Number(inputField.value);
    if (event.key === "Enter") {
      func(event);
    }
  });

  let func = function (event) {

    var selected = getSelectedShapes();
    resetSelectedShapes();
    resetSelectionStep(); // Reset selection step when performing offset
    makeOffset(selected as any[], a.mouse, a.userInputValue * 2 * a.zlc);
    document.removeEventListener("click", func);
    clearTooltipAll();
    setMode("select");

  };

  document.body.appendChild(tooltip);
  inputField.focus();
  inputField.select();

  document.addEventListener("click", func);

  pushSelected();
}

function handleMakeOffsetGuide(event) {
  if (a.blockUI) return;
  if (!getSelectedShapes().length) return;

  setMode("guide");
  // предотвратить передачу символа N в поле ввода
  event.preventDefault();

  var { tooltip, inputField } = createTooltipWithInput(200, 0, s.tooltipBottomOffset);
  // назначить inputField глобальному a, что того, чтобы изменить значение из функции handleMouseMove;
  a.currentInputField = inputField;

  inputField.addEventListener("keyup", function (event) {
    a.userInputValue = Number(inputField.value);
    if (event.key === "Enter") {
      func(event);
    }
  });
  document.addEventListener("click", func);

  addToCurrentListeners(inputField, "keyup", func);
  addToCurrentListeners(document, "click", func);

  document.body.appendChild(tooltip);
  inputField.focus();
  inputField.select();


  function func(event) {

    var selected = getSelectedShapes();
    resetSelectedShapes();
    resetSelectionStep(); // Reset selection step when performing offset guide
    makeOffsetGuide(selected, a.mouse, a.userInputValue * 2 * a.zlc);
    document.removeEventListener("click", func);
    clearTooltipAll();
    setMode("select");

  }
}

function handleSelectAll(event) {
  if (a.blockUI) return;
  event.preventDefault();
  selectAllShapes();
  resetSelectionStep(); // Reset selection step when selecting all
  textLinesCollection.filter(t => !t.hidden).forEach(s => s.selected = true);
  a.selected$.next(getDisplayedShapes());
  drawShapes();

  // --- text
  selectedText$.next(textLinesCollection.filter(t => !t.hidden));
  cnv.clear();
  rerender();
  // --- text
}

/**
 * Prints nodes from a branch path with their attributes
 * @param graf - The graph containing the nodes
 * @param branchPath - Array of node IDs in the branch path
 */
function printBranchNodes(graf: Graf, branchPath: string[]) {
  const NODE_STYLE_HEADER = 'font-size: 16px; font-weight: bold; background-color: #4CAF50; color: white; padding: 4px 8px; border-radius: 4px';
  const NODE_STYLE_LABEL = 'font-weight: bold; color: #2196F3';
  const NODE_STYLE_VALUE = 'color: #666';
  const NODE_STYLE_BOOLEAN_TRUE = 'color: #4CAF50; font-weight: bold';
  const NODE_STYLE_BOOLEAN_FALSE = 'color: #F44336; font-weight: bold';
  const NODE_STYLE_FLOW_IN = 'color: #00ff00; font-weight: bold';
  const NODE_STYLE_FLOW_OUT = 'color: #ff0000; font-weight: bold';
  const NODE_STYLE_FLOW_UNKNOWN = 'color: #808080; font-weight: bold';
  const CONSOLE_STYLE_TITLE = 'font-size: 20px; font-weight: bold; background-color: yellow';
  const CONSOLE_STYLE_SUMMARY = 'font-size: 20px; font-weight: bold; background-color: #ececec';

  console.log(`%c** Branch Nodes with Attributes **`, CONSOLE_STYLE_TITLE);
  
  if (!branchPath || branchPath.length === 0) {
    console.log(`%cNo nodes in branch path`, NODE_STYLE_VALUE);
    return;
  }

  // Filter to only nodes that exist in the graph
  const validNodes = branchPath.filter(nodeId => graf.hasNode(nodeId));
  
  if (validNodes.length === 0) {
    console.log(`%cNo valid nodes found in graph for this branch`, NODE_STYLE_VALUE);
    return;
  }

  validNodes.forEach((nodeId, index) => {
    const attrs = graf.getNodeAttributes(nodeId) as any;
    if (!attrs) return;
    
    // Extract child IDs from fittings
    const childIds: string[] = [];
    if (attrs.fittings && Array.isArray(attrs.fittings)) {
      attrs.fittings.forEach((fitting: any) => {
        if (fitting && typeof fitting === 'object' && 'childNodeId' in fitting) {
          childIds.push(fitting.childNodeId);
        }
      });
    }

    // Format flow direction with color
    const flowDirection = attrs.flowDirection;
    let flowDirectionStyle = NODE_STYLE_FLOW_UNKNOWN;
    let flowDirectionText = 'UNKNOWN';
    if (flowDirection === FlowDirection.IN) {
      flowDirectionStyle = NODE_STYLE_FLOW_IN;
      flowDirectionText = 'IN';
    } else if (flowDirection === FlowDirection.OUT) {
      flowDirectionStyle = NODE_STYLE_FLOW_OUT;
      flowDirectionText = 'OUT';
    }

    // Print node header
    console.log(`%cNode ${index + 1}: ${nodeId}`, NODE_STYLE_HEADER);
    
    // Print parent ID (node ID itself)
    console.log(`  %cParent ID:%c ${nodeId}`, NODE_STYLE_LABEL, NODE_STYLE_VALUE);
    
    // Print child IDs
    if (childIds.length > 0) {
      console.log(`  %cChild IDs:%c [${childIds.join(', ')}]`, NODE_STYLE_LABEL, NODE_STYLE_VALUE);
    } else {
      console.log(`  %cChild IDs:%c none`, NODE_STYLE_LABEL, NODE_STYLE_VALUE);
    }
    
    // Print label
    console.log(`  %cLabel:%c ${attrs.label || 'N/A'}`, NODE_STYLE_LABEL, NODE_STYLE_VALUE);
    
    // Print isTerminal
    const isTerminal = attrs.isTerminal === true;
    console.log(`  %cisTerminal:%c ${isTerminal}`, NODE_STYLE_LABEL, isTerminal ? NODE_STYLE_BOOLEAN_TRUE : NODE_STYLE_BOOLEAN_FALSE);
    
    // Print isOpenEnd
    const isOpenEnd = attrs.isOpenEnd === true;
    console.log(`  %cisOpenEnd:%c ${isOpenEnd}`, NODE_STYLE_LABEL, isOpenEnd ? NODE_STYLE_BOOLEAN_TRUE : NODE_STYLE_BOOLEAN_FALSE);
    
    // Print flowDirection
    console.log(`  %cFlow Direction:%c ${flowDirectionText}`, NODE_STYLE_LABEL, flowDirectionStyle);
    
    console.log(''); // Empty line for spacing
  });

  console.log(`%cTotal branch nodes: ${validNodes.length}`, CONSOLE_STYLE_SUMMARY);
}

/**
 * Prints tee flow direction types for tees in a branch
 * @param branch - The branch containing tee elements
 */
function printTeeFlowDirectionTypes(branch: any) {
  const CONSOLE_STYLE_TITLE = 'font-size: 18px; font-weight: bold; background-color: #9C27B0; color: white; padding: 4px 8px; border-radius: 4px';
  const CONSOLE_STYLE_LABEL = 'font-weight: bold; color: #2196F3';
  const CONSOLE_STYLE_VALUE = 'color: #666';
  const CONSOLE_STYLE_ON_PASS = 'color: #4CAF50; font-weight: bold';
  const CONSOLE_STYLE_ON_TURN = 'color: #FF9800; font-weight: bold';
  const CONSOLE_STYLE_UNKNOWN = 'color: #808080; font-weight: bold';
  const CONSOLE_STYLE_SUMMARY = 'font-size: 16px; font-weight: bold; background-color: #ececec';

  console.log(`%c** Tee Flow Direction Types for Branch: ${branch.id} **`, CONSOLE_STYLE_TITLE);

  // Filter tees from branch elements
  const teeElements = branch.elements.filter((elem: any) => elem instanceof Tee);

  if (teeElements.length === 0) {
    console.log(`%cNo tees found in this branch`, CONSOLE_STYLE_VALUE);
    return;
  }

  teeElements.forEach((tee: any, index: number) => {
    const flowType = tee.flowDirectionType?.get(branch.id) || 'UNKNOWN';
    
    let flowTypeStyle = CONSOLE_STYLE_UNKNOWN;
    if (flowType === 'on pass') {
      flowTypeStyle = CONSOLE_STYLE_ON_PASS;
    } else if (flowType === 'on turn') {
      flowTypeStyle = CONSOLE_STYLE_ON_TURN;
    }

    console.log(`%cTee ${index + 1} (ID: ${tee.id})`, CONSOLE_STYLE_LABEL);
    console.log(`  %cFlow Direction Type:%c ${flowType}`, CONSOLE_STYLE_LABEL, flowTypeStyle);
    
    // Show all flow direction types for this tee across all branches
    if (tee.flowDirectionType && tee.flowDirectionType.size > 0) {
      const allTypes: string[] = [];
      tee.flowDirectionType.forEach((type: string, branchId: string) => {
        allTypes.push(`${branchId}: ${type}`);
      });
      console.log(`  %cAll branch types:%c ${allTypes.join(', ')}`, CONSOLE_STYLE_LABEL, CONSOLE_STYLE_VALUE);
    }
    
    // Log tee dp value
    const teeDp = tee.net?.dp;
    if (teeDp !== undefined && teeDp !== null && !isNaN(teeDp)) {
      console.log(`  %cTee DP:%c ${teeDp.toFixed(2)} Pa`, CONSOLE_STYLE_LABEL, CONSOLE_STYLE_VALUE);
    } else {
      console.log(`  %cTee DP:%c Not calculated`, CONSOLE_STYLE_LABEL, CONSOLE_STYLE_UNKNOWN);
    }
    
    console.log(''); // Empty line for spacing
  });

  console.log(`%cTotal tees in branch: ${teeElements.length}`, CONSOLE_STYLE_SUMMARY);
}

/**
 * Обработчик события выбора элементов сети
 * Реализует трёхшаговую логику выбора: сначала ветка, затем вся сеть, затем сброс
 * @param event - Событие взаимодействия пользователя
 */
function handleSelect(event) {
  // ============================================
  // ПРОВЕРКА БЛОКИРОВКИ И ИНИЦИАЛИЗАЦИЯ
  // ============================================
  // Если UI заблокирован (например, открыто диалоговое окно), прекращаем обработку
  if (a.blockUI) return;

  // Сбрасываем предыдущие выделения и состояние выбора
  resetSelectedShapes();
  reset();
  setMode("select");

  // ============================================
  // ПОИСК ЭЛЕМЕНТА ПОД КУРСОРОМ МЫШИ
  // ============================================
  // Фильтруем все отображаемые фигуры и находим те, которые находятся под курсором мыши
  // Используем метод isinSelectBoundary для проверки попадания курсора в границы фигуры
  const isinSelectBoundary = getDisplayedShapes().filter(shape => checkFunction(shape, "isinSelectBoundary", a.mouse));

  if (isinSelectBoundary.length > 0) {
    // Берём первый найденный элемент под курсором (если их несколько, выбираем первый)
    let segment = isinSelectBoundary[0] as Shape;
    let route;
    
    // Получаем ветку, к которой принадлежит выбранный элемент
    // Ветка - это последовательность связанных элементов от терминала до терминала
    let branch = getBranchByElement(segment as Line | Block | ElbowBlock | Tee);
    let graf: Graf | undefined;

    // ============================================
    // ПОИСК ГРАФА ДЛЯ СЕТЕВЫХ РЕЖИМОВ
    // ============================================
    // Для режимов работы с сетями (линия, эскиз сети, воздуховод) необходимо найти граф,
    // который содержит выбранный элемент. Граф представляет структуру всей сети.
    if (a.drawingMode == DrawingModes.line || a.drawingMode == DrawingModes.networkSketch || a.drawingMode == DrawingModes.duct) {
      // Шаг 1: Пытаемся найти граф по точкам начала и конца сегмента
      // Это самый быстрый способ, так как точки сегмента должны быть узлами графа
      graf = Graf.findGraph(a.graphs, [getShapeStart(segment).id, getShapeEnd(segment).id]);

      // Шаг 2: Если граф не найден по точкам сегмента, ищем через узлы арматуры
      // Это может произойти, если сегмент соединён через фитинги (тройники, отводы)
      if (!graf) {
        const segmentStart = getShapeStart(segment);
        const segmentEnd = getShapeEnd(segment);

        // Перебираем все доступные графы и ищем тот, который содержит узлы, связанные с нашим сегментом
        for (let i = 0; i < a.graphs.length; i++) {
          const currentGraph = a.graphs[i];
          const nodes = currentGraph.nodes();

          // Проверяем, есть ли в этом графе узлы, соответствующие точкам нашего сегмента
          const hasMatchingNode = nodes.some(node => {
            if (typeof node === 'string') {
              // Для строковых узлов проверяем прямое совпадение ID точек сегмента
              return (node === segmentStart.id || node === segmentEnd.id);
            } else if (node && node.id) {
              // Для объектных узлов проверяем совпадение по ID или originalId
              // originalId может быть установлен при объединении узлов в канонические точки
              return (node.id === segmentStart.id || node.id === segmentEnd.id ||
                node.originalId === segmentStart.id || node.originalId === segmentEnd.id);
            }
            return false;
          });

          // Если нашли совпадение, используем этот граф и прекращаем поиск
          if (hasMatchingNode) {
            graf = currentGraph;
            break;
          }
        }
      }

      // Получаем все элементы сети, связанные с узлами найденного графа
      // Это позволяет получить полный маршрут сети для последующего выделения
      route = getNetworkElementsByNodes(graf?.nodes());
    }

    // ============================================
    // ТРЁХШАГОВАЯ ЛОГИКА ВЫБОРА
    // ============================================
    // Реализуем последовательное выделение: ветка → вся сеть → сброс
    // Это позволяет пользователю постепенно увеличивать область выбора
    
    if (a.selectionStep === 0) {
      // ============================================
      // ШАГ 1: ВЫБОР ВЕТКИ (ПЕРВОЕ НАЖАТИЕ 'S')
      // ============================================
      // Выделяем все элементы, принадлежащие найденной ветке
      // Ветка содержит последовательность элементов от одного терминала до другого
      if (branch && branch.elements && Array.isArray(branch.elements)) {
        branch.elements.forEach(e => {
          if (e) {
            e.isSelected = true;
          }
        });
      }
      
      // Выводим информацию об узлах ветки в консоль для отладки
      // Это помогает понять структуру ветки и проверить корректность её построения
      if (graf && branch && branch.path && branch.path.length > 0) {
        // printBranchNodes(graf, branch.path);
        // Log tee flow direction types for this branch
        // printTeeFlowDirectionTypes(branch);
      }
      
      // Переходим к следующему шагу выбора
      a.selectionStep = 1;
      
    } else if (a.selectionStep === 1) {
      // ============================================
      // ШАГ 2: ВЫБОР ВСЕЙ СЕТИ (ВТОРОЕ НАЖАТИЕ 'S')
      // ============================================
      // Выделяем выбранный сегмент и все элементы маршрута сети
      // Это позволяет выделить всю связанную сеть целиком
      segment.isSelected = true;
      route?.forEach(s => s.isSelected = true);
      
      // Переходим к финальному шагу
      a.selectionStep = 2;
      
    } else {
      // ============================================
      // ШАГ 3: СБРОС ВЫБОРА (ТРЕТЬЕ НАЖАТИЕ 'S')
      // ============================================
      // Сбрасываем шаг выбора, возвращаясь к начальному состоянию
      // Выделения уже очищены вызовом resetSelectedShapes() в начале функции
      a.selectionStep = 0;
    }

    // Уведомляем систему о изменении выделенных элементов
    // Это обновляет UI и позволяет другим компонентам реагировать на выбор
    a.selected$.next(getSelectedShapes());

  } else {
    // ============================================
    // ОБРАБОТКА СЛУЧАЯ ОТСУТСТВИЯ ЭЛЕМЕНТА ПОД КУРСОРОМ
    // ============================================
    // Если под курсором нет элементов, сбрасываем шаг выбора
    // Это гарантирует, что следующее нажатие начнёт выбор с начала
    a.selectionStep = 0;
  }

  // Перерисовываем все фигуры с учётом новых выделений
  drawShapes();
}

function handleRemoveGuides(event) {
  setashapes(getDisplayedShapes().filter(s => s.type !== "guide"));
  updateAndDrawShapes();
  setMode(CommandList.cm.select.type);
}

function handleJoin(event) {
  if (a.blockUI) return;

  let selectedSegments = getSelectedShapes().filter(s => s.type === ObjectTypes.line);
  if (selectedSegments.length > 2) return;

  var seg1 = selectedSegments[0];
  var seg2 = selectedSegments[1];


  if (seg1 && seg2) {
    var intersection = findIntersection(seg1 as Line, seg2 as Line);
  } else {
    return;
  }

  if (intersection) {
    let lengthStart1, lengthStart2, lengthEnd1, lengthEnd2;
    lengthStart1 = getShapeStart(seg1).distanceTo(intersection);
    lengthStart2 = getShapeStart(seg2).distanceTo(intersection);
    lengthEnd1 = getShapeEnd(seg1).distanceTo(intersection);
    lengthEnd2 = getShapeEnd(seg2).distanceTo(intersection);
    if (lengthStart1 < lengthEnd1) {
      (seg1 as any).start = intersection;
    } else {
      (seg1 as any).end = intersection;
    }
    if (lengthStart2 < lengthEnd2) {
      (seg2 as any).start = intersection;
    } else {
      (seg2 as any).end = intersection;
    }
    resetSelectedShapes();
    resetSelectionStep(); // Reset selection step when joining segments
  }

  updateAndDrawShapes();

}

function handleCreateTheSame(event) {
  if (a.blockUI) return;

  let selected = getSelectedShapes();
  if (selected) {
    let seg = selected[0];
    let color = seg.color;
    let thickness = seg.thickness;
    let rtype = seg.rtype;

    a.line.color = color;
    a.line.thickness = thickness;
    a.line.rtype = rtype;

    a.circle.color = color;
    a.circle.thickness = thickness;
    a.circle.rtype = rtype;

    a.rectangle.color = color;
    a.rectangle.thickness = thickness;
    a.rectangle.rtype = rtype;

    let type = seg.type;
    if (type === ObjectTypes.line) {
      setMode(ObjectTypes.line);
    } else if (type === ObjectTypes.circle) {
      setMode(ObjectTypes.circle);
    } else if (type === ObjectTypes.rectangle) {
      setMode(ObjectTypes.rectangle);
    }
  }

}

function handleHide(event) {
  if (a.blockUI) return;
  hideSelectedShapes();
  updateAndDrawShapes();

  // --- text
  textLinesCollection.filter(s => s.selected).forEach(t => {
    t.selected = false;
    t.hidden = true;
  });

  cnv.clear();
  rerender();
  // --- text

}

function handleDisplayAll(event) {
  if (a.blockUI) return;

  displayHiddenShapes();
  updateAndDrawShapes();

  // --- text
  textLinesCollection.filter(t => t.hidden).forEach(t => t.hidden = false);

  cnv.clear();
  rerender();
  // --- text

}

function handleEscape(event) {

  resetSelectedShapes();
  resetSelectionStep(); // Reset selection step when escaping
  reset();
  drawShapes();
  /**
   * Здесь есть конфликт с библиотекой canvas-text.
   * Если установить селект, то в библиотеке не будет выхода из режима текста. Поэтому строка закомментирована
   */
  // setMode(mode_elem, 'select');
  a.selectFrame.start = null;
  a.selectFrame.end = null;

  t.editId = null;
  a.isMouseDown = false;
  a.clickLineStart = false;
  a.clickRectangleStart = false;
  a.clickCircleStart = false;
  a.clickSquareStart = false;
  // режим 'select' устанавливается в библиотеке canvas-text
  // setMode(mode_elem, 'select');

  a.selected$.next(getSelectedShapes());

  // удалить все дополнительно добавленные события
  detachAllListeners();
  clearTooltipAll();

}

function handleDelete(event) {
  // if (a.blockUI) return;

  deleteShapes();
  updateAndDrawShapes();
  clearTooltipAll();

  a.selected$.next(getSelectedShapes());

  setMode(CommandList.cm.select.type);

  // Rebuild graph structures after deletion
  if (a.drawingMode === DrawingModes.line || a.drawingMode === DrawingModes.networkSketch || a.drawingMode === DrawingModes.duct) {
    a.gman.detectRoutes(true);
  }
}

function handleSaveShapesToDatabase(event) {
  event.preventDefault();
  dbClear();
  dbCreate(a.shapes);
  dbCreate(textLinesCollection);
  dbCreate(CommandList.cmSealed());
  localStorage.setItem("zlc", a.zlc.toString());
}

function handleStampClick(event) {
  event.preventDefault();
  a.isStampPdfVisible = !a.isStampPdfVisible;
  a.stamp$.next(a.isStampPdfVisible);
}

/**
 * Функция для черчения отрезка
 * @param mouse - точка, по которой произошла нажатия мыши
 * @param aStart - точка передаётся из модуля down, равна или позиции мыши или позиции магнита
 */
function handleLine(mouse: Point, aStart: Point) {

  connect(getDisplayedShapes()); // TODO: ВАЖНО! startJ.id назначается в этой функции, без этого не работает move-route-part

  if (!a.clickLineStart) {

    a.line.start = aStart;
    a.clickLineStart = true;

  } else if (a.clickLineStart) {


    a.line.end = assignAend(mouse);

    let seg = a.line.getClone();

    addShapes(seg);

    createNetworkElements(seg);

    // Re-detect routes to include any newly created fittings and build graph structures
    if (a.drawingMode === DrawingModes.line || a.drawingMode === DrawingModes.networkSketch || a.drawingMode === DrawingModes.duct) {
      a.gman.detectRoutes(true);
    }

    a.clickLineStart = false;

    a.line.reset();

  }

}



export function createNetworkElements(shape: any) {
  if (a.drawingMode === ObjectTypes.duct || a.drawingMode === ObjectTypes.pipe) {
    // Initialize network info for the line segment
    shape.net = a.preNetInfo.getClone();
    shape.net.setRealLenMet(shape.getLength(), a.zlc);
    
    createElbowBlock(a.end, shape);
    createTee(a.end, shape);
  }
}



/*
* Функция добавляет отвод-блок
* */
function createElbowBlock(mouseOrMagnet: Point, segmentCurrent: Line) {



  var elbow: ElbowBlock;

  getDisplayedShapes().filter((s: Shape) => s instanceof Line)
    .filter((l: Line) => {
      let cond1 = isin(segmentCurrent.start, l.start);
      let cond2 = isin(segmentCurrent.end, l.start);
      let cond3 = isin(segmentCurrent.start, l.end);
      let cond4 = isin(segmentCurrent.end, l.end);
      let cond5 = l.id !== segmentCurrent.id;

      if ((cond1 || cond2 || cond3 || cond4) && cond5) return true;
      return false;

    })
    .forEach(createElbow());

  updateAndDrawShapes();

  function createElbow(): (value: Line, index: number, array: Line[]) => void {
    return (segmentBase: Line) => {

      let angleDeg = segmentCurrent.getAngleBetween(segmentBase);
      elbow = createNewElbow(segmentBase, segmentCurrent, angleDeg, mouseOrMagnet);

      elbow.connectRefSegments(segmentBase, segmentCurrent);

      addShapes(elbow);

    };
  }

  function createNewElbow(segmentBase: Line, segmentCurrent: Line, angleDeg: any, mouseOrMagnet: Point) {
    // Calculate center point from intersection
    var center = findIntersection(segmentBase, segmentCurrent) || mouseOrMagnet;
    
    var elbow = new ElbowBlock(
      center,           // center: Point
      15,               // sideLength: number
      angleDeg,         // angleDeg: number
      segmentBase,      // segmentBase: Line
      segmentCurrent,   // segmentCurrent: Line
      1,                // rd: number
      [200, 200],       // size: number[] | number
      1000              // flowCmh: number
    );
    
    elbow.assignConnectionPoints();
    return elbow;
  }

}

/**
 * Функция добавляет тройник
 */
function createTee(mouseOrMagnet: Point, segmentCurrent: Line) {
  var otherSegments = getDisplayedShapes().filter((s: Shape) => s instanceof Line).filter((l: Line) => l.id !== segmentCurrent.id);

  // выход, если ни начальная, ни конечная точка текущего отрезка не находится в границе какого-либо другого отрезка
  // Проверяем оба конца: если ни один из них не на другом отрезке, то тройник не нужен
  if (otherSegments.every((l: Line) => !l.isinSelectBoundary(mouseOrMagnet) && !l.isinSelectBoundary(segmentCurrent.start))) return;

  otherSegments.forEach((segmentBase: Line) => {

    if (segmentBase.isinSelectBoundary(mouseOrMagnet)) {
      // Случай 1: Конец текущего отрезка на другом отрезке (начало на пустом месте)
      let tee = new Tee(ObjectTypes.rect, ObjectTypes.exhaust, ObjectTypes.pass, 100, 100, 100, 100, 100, 100, 1000, 500, 90, mouseOrMagnet, segmentBase, segmentCurrent);
      tee.connectedSegStart = segmentBase.start;
      tee.connectedSegEnd = segmentBase.end;
      tee.center = mouseOrMagnet;

      let lines = segmentBase.breakMe(tee.base1, tee.base2);
      segmentBase.isSelected = true;

      addShapes(lines);
      deleteShapes();

      segmentCurrent.end = tee.side;
      tee.assignConnectionPoints();
      addShapes(tee);

      updateAndDrawShapes();
    }
    else if (segmentBase.isinSelectBoundary(segmentCurrent.start)) {
      // Случай 2: Начало текущего отрезка на другом отрезке (конец на пустом месте)
      let tee = new Tee(ObjectTypes.rect, ObjectTypes.exhaust, ObjectTypes.pass, 100, 100, 100, 100, 100, 100, 1000, 500, 90, segmentCurrent.start, segmentBase, segmentCurrent);
      tee.connectedSegStart = segmentBase.start;
      tee.connectedSegEnd = segmentBase.end;
      tee.center = segmentCurrent.start;

      let lines = segmentBase.breakMe(tee.base1, tee.base2);
      segmentBase.isSelected = true;

      addShapes(lines);
      deleteShapes();

      segmentCurrent.start = tee.side;
      tee.assignConnectionPoints();
      addShapes(tee);

      updateAndDrawShapes();
    }
  });
}



function handleRectangle(mouse: Point) {
  if (!a.clickRectangleStart) {
    a.rectangle.p1 = a.start;

    a.clickRectangleStart = true;
  } else if (a.clickRectangleStart) {
    if (a.magnetPosition) {
      a.end = { ...a.magnetPosition };
    } else {
      a.end = { ...mouse };
    }
    a.rectangle.width = a.end.x - a.rectangle.p1.x;
    a.rectangle.height = a.end.y - a.rectangle.p1.y;

    a.rectangle.p2 = new Point(a.rectangle.p1.x + a.rectangle.width, a.rectangle.p1.y);
    a.rectangle.p3 = new Point(a.rectangle.p1.x + a.rectangle.width, a.rectangle.p1.y + a.rectangle.height);
    a.rectangle.p4 = new Point(a.rectangle.p1.x, a.rectangle.p1.y + a.rectangle.height);

    a.rectangle.updateCenter();

    let shape: Rectangle = a.rectangle.getClone();
    shape.updatePoints();

    addShapes(shape);


    a.clickRectangleStart = false;
    clearTooltipAll();
  }
}

function handleSquare(mouse) {
  if (!a.clickSquareStart) {
    a.rectangle.p1 = a.start;
    a.clickSquareStart = true;
  } else if (a.clickSquareStart) {
    if (a.magnetPosition) {
      a.end = { ...a.magnetPosition };
    } else {
      a.end = { ...mouse };
    }

    let s = { ...a.rectangle.p1 };
    a.rectangle.width = (a.end.x - s.x);

    const height = (a.end.y - s.y);
    if (height < 0 && a.rectangle.width < 0) {
      a.rectangle.height = a.rectangle.width;
    } else if (height < 0 && a.rectangle.width > 0) {
      a.rectangle.height = -a.rectangle.width;
    } else if (height > 0 && a.rectangle.width < 0) {
      a.rectangle.height = -a.rectangle.width;
    } else if (height > 0 && a.rectangle.width > 0) {
      a.rectangle.height = a.rectangle.width;
    }
    a.rectangle.p2 = new Point(s.x + a.rectangle.width, s.y);
    a.rectangle.p3 = new Point(s.x + a.rectangle.width, s.y + a.rectangle.height);
    a.rectangle.p4 = new Point(s.x, s.y + a.rectangle.height);

    addShapes(a.rectangle.getClone());
    a.clickSquareStart = false;
    clearTooltipAll();
  }
}

function handleCircle() {
  if (!a.clickCircleStart) {
    a.circle.center = a.start;
    a.clickCircleStart = true;
  } else if (a.clickCircleStart) {
    a.circle.radius = Math.hypot((a.end.x - a.start.x), a.end.y - a.start.y);
    a.circle.setSelectBoundary();
    addShapes(a.circle.getClone());
    a.clickCircleStart = false;
    clearTooltipAll();
  }
}


function handleMoveMousedown(mouse) {

  let block = (getSelectedShapes().filter(s => s instanceof Block || s instanceof ElbowBlock) as (Block | ElbowBlock)[]);


  if (!a.clickMoveStart) {
    /**
     * a.start - это текущая позиция щелчка, учитывающая также находится ли курсор на каком-нибудь магните
     * a.start назначается в модуле down
     */
    a.clickMoveStart = { ...a.start };

    if (block.length === 1) {
      let freeShape = block[0];
      initForFreeTransform(freeShape, mouse);
    }

    // --- text
    textLinesCollection.filter(t => t.selected).forEach(t => {
      t.moveXclick = t.start.x;
      t.moveYclick = t.start.y;
    });
    // --- text

  } else if (a.clickMoveStart) {

    let move_mat = getMoveMatrix(a.clickMoveStart, a.start);

    if (block.length === 1) {

      let freeShape = block[0];

      transformFreeShape(a.clickMoveStart, a.start, freeShape, a.cpointsInitAngleDeg, mouse);
      let moved = false;
      moved = movePipe(freeShape, move_mat, a.cSegs, [a.cpoints.p1, a.cpoints.p2]);
      if (!moved) {
        breakPipe(mouse, freeShape);
      }
      let segments = getLinesIfSelected();
      checkConnections(freeShape, segments as any[]);

    } else {
      getSelectedShapes().forEach(s => transformPointByMatrixDependingOnShapeType(s, move_mat));
    }

    // --- text
    updateTextPositions(textLinesCollection, a.clickMoveStart, a.start);
    // --- text

    a.clickMoveStart = null;

    g.context.uniformMatrix3fv(g.u_move, false, createIdentityMatrix());
    g.context.uniformMatrix3fv(g.u_rotate, false, createIdentityMatrix());

    resetCpoints();
  }
}

export function initForFreeTransform(free, mouseOrPoint) {
  if (free) {

    let { cp1, cp2 } = free.getCpoints();

    setCpoint1(cp1);
    setCpoint2(cp2);

    if (isin(a.cpoints.p1, mouseOrPoint)) {
      setCpointClick("p1");
    } else if (isin(a.cpoints.p2, mouseOrPoint)) {
      setCpointClick("p2");
    }

    if (!cp2) {
      // указана только одна точка присоединения
      setCpointInitAngleDeg(0);
    } else {
      let vec = new Vector(a.cpoints.p1, a.cpoints.p2);
      let vec0 = Vector.getVec0();
      setCpointInitAngleDeg(vec.getAngleDeg(vec0));
    }

    let cSegs = free.getConnectedSegments();
    segCsegs(cSegs);

  }
}

function transformFreeShape(clickStart: Point, aStart: Point, free: (Block | ElbowBlock), cpointsInitAngle, mouse: Point) {

  if (!free) return;


  let rotateMat;

  let segments = getDisplayedShapes().filter((s: Shape) => s instanceof Line);

  for (const s of segments) {
    if (s.isinSelectBoundary(mouse)) {

      if (a.cpointsClick === "p1" || a.cpointsClick === "p2") {

        rotateMat = getFreeShapeRotateMatByMouse(s, cpointsInitAngle, aStart);
      } else {
        rotateMat = mat3.create();
      }
    }
  }


  let move_mat = getMoveMatrix(clickStart, aStart);
  transformPointByMatrixDependingOnShapeType(free, move_mat);

  if (rotateMat && !(free instanceof ElbowBlock)) {
    transformPointByMatrixDependingOnShapeType(free, rotateMat);
  }

}

function handleCopyMousedown(mouse: Point) {

  /**
   * Может быть выбрана одна или несколько фигур free. Если выбрана одна фигура -
   * то срабатывает корректировка положения в зависимости от положения трубы,
   * если же выбрано несколько фигур - то функция работает как обычно.
   */

  let blocks: Block[] = getSelectedShapes().filter((s: Shape) => s.type === ObjectTypes.block) as Block[];

  if (!a.clickCopyStart) {
    a.clickCopyStart = a.start;

    getSelectedShapes().forEach((shape: Shape) => {
      a.shapes.push(shape.getClone());
    });


    // или для всех вновь скопированных фигур найти сеть или отдельные сети и назначить
    // им новые routeId


    a.gman.detectRoutes(false);


    if (blocks.length === 1) {
      let freeShape: Block = blocks[0];
      initForFreeTransform(freeShape, mouse);
    }


    // --- text
    let array = [];
    textLinesCollection.filter(t => t.selected).forEach(t => {
      array.push(t.clone());
      t.copyClick = { ...t.start };
    });

    array.forEach(item => {
      item.selected = false;
      textLinesCollection$.next({ fnName: "push", line: item });
    });
    // --- text

  } else if (a.clickCopyStart) {

    /**
     * TODO: нужно сделать так, чтобы была возможность переместить несколько блоков одновременно
     */

    let move_mat = getMoveMatrix(a.clickCopyStart, a.start);



    let isOneBlockSelected = (blocks.length === 1 && getSelectedShapes().length === 1)
    if (isOneBlockSelected) {

      // блок срабатывает если выбрана только одна фигура и эта фигура - блок

      let block: Block = blocks[0];

      transformFreeShape(a.clickCopyStart, a.start, block, a.cpointsInitAngleDeg, mouse);
      breakPipe(mouse, block);

      // здесь нужно получить участки после разрыва
      // Use getDisplayedShapes to get all segments including newly created ones from breakPipe
      let segments = getDisplayedShapes().filter((s: Shape) => s instanceof Line) as Line[];
      checkConnections(block, segments as any[]);

      // Re-detect routes to include the newly placed block and rebuild graphs
      // Ensure shapes are updated before route detection
      updateAndDrawShapes();
      a.gman.detectRoutes(true);

    } else {

      let segments = getLinesIfSelected();
      blocks.forEach((b: Block) => {
        checkConnections(b, segments as any[]);
      });

      // Re-detect routes to include the newly placed blocks and rebuild graphs
      a.gman.detectRoutes(true);

      getSelectedShapes().forEach((s: Shape) => transformPointByMatrixDependingOnShapeType(s, move_mat));

    }


    // --- text

    textLinesCollection.filter(t => t.selected).forEach(text => {
      const deltaX = a.clickCopyStart.x - a.start.x;
      const deltaY = a.clickCopyStart.y - a.start.y;
      text.start.x = text.copyClick.x - deltaX;
      text.start.y = text.copyClick.y - deltaY;
      text.edit = null;
    });

    cnv.clear();
    rerender();


    // --- text



    a.clickCopyStart = null;

    g.context.uniformMatrix3fv(g.u_move, false, createIdentityMatrix());
    g.context.uniformMatrix3fv(g.u_rotate, false, createIdentityMatrix());

  }


}





function handleRotateMousedown(mouse) {
  if (!a.clickRotateStart) {
    a.clickRotateStart = { ...a.start };
  } else {
    const rotate_mat = getRotateMatrix(a.clickRotateStart, mouse);
    getSelectedShapes().forEach(shape => transformPointByMatrixDependingOnShapeType(shape, rotate_mat));
    a.clickRotateStart = null;
    g.context.uniformMatrix3fv(g.u_rotate, false, mat3.create());
  }
}

function handleRotateAndCopyMousedown(mouse) {
  if (!a.clickRotateStart) {
    a.clickRotateStart = { ...a.start };
    a.shapes.filter(shape => shape.isSelected).forEach(shape => {
      addShapes(shape.getClone());
    });

  } else {
    const rotate_mat = getRotateMatrix(a.clickRotateStart, mouse);
    getSelectedShapes().forEach(shape => transformPointByMatrixDependingOnShapeType(shape, rotate_mat));
    a.clickRotateStart = null;
    g.context.uniformMatrix3fv(g.u_rotate, false, mat3.create());
  }
}

function handleMirrorMousedown(mouse) {
  if (!a.clickMirrorStart) {
    a.clickMirrorStart = { ...a.start };
    getSelectedShapes().forEach(shape => addShapes(shape.getClone()));

  } else {
    const mirror_mat = getMirrorMatrix(a.clickMirrorStart, mouse);
    getSelectedShapes().forEach(shape => transformPointByMatrixDependingOnShapeType(shape, mirror_mat));
    a.clickMirrorStart = null;
    g.context.uniformMatrix3fv(g.u_rotate, false, mat3.create());
  }
}

function handleScaleMousedown(mouse) {
  if (!a.clickScaleStart1 && !a.clickScaleStart2) {
    a.clickScaleStart1 = { ...a.start };
  } else if (a.clickScaleStart1 && !a.clickScaleStart2) {
    a.clickScaleStart2 = { ...a.start };
    a.clickScaleBaseDistanceX = a.clickScaleStart2.x - a.clickScaleStart1.x;
    a.clickScaleBaseDistanceY = a.clickScaleStart2.y - a.clickScaleStart1.y;
    a.clickScaleBaseDistance = Math.hypot(a.clickScaleBaseDistanceX, a.clickScaleBaseDistanceY);
    let minX = 10000;
    let maxX = 0;

    getSelectedShapes().forEach(shape => {
      switch (shape.constructor.name) {
        case cl.cm.line.type:
          let start = getShapeStart(shape);
          let end = getShapeEnd(shape);
          if (start.x < minX) {
            minX = start.x;
          }
          if (end.x < minX) {
            minX = end.x;
          }
          if (start.x > maxX) {
            maxX = start.x;
          }
          if (end.x > maxX) {
            maxX = end.x;
          }
          break;
        case cl.cm.rectangle.type:
          let points = [(shape as any).p1, (shape as any).p2, (shape as any).p3, (shape as any).p4];
          points.forEach(point => {
            if (point.x < minX) {
              minX = point.x;
            }
            if (point.x > maxX) {
              maxX = point.x;
            }
          });
          break;
        case cl.cm.circle.type:
          let center = getShapeCenter(shape);
          let radius = getShapeRadius(shape);
          let circleMinX = center.x - radius;
          let circleMaxX = center.x + radius;
          if (circleMinX < minX) {
            minX = circleMinX;
          }
          if (circleMaxX > maxX) {
            maxX = circleMaxX;
          }
          break;
        default:
          break;
      }
    });
    a.clickScaleShapeDistance = maxX - minX;
  } else if (a.clickScaleStart1 && a.clickScaleStart2) {
    const dx = (mouse.x - a.clickScaleStart2.x);
    const dy = (mouse.y - a.clickScaleStart2.y);

    const distX = a.clickScaleBaseDistanceX + dx;
    const distY = a.clickScaleBaseDistanceY + dy;


    const scale_mat = getScaleMatrix(a.clickScaleStart1, distX, distY, a.clickScaleBaseDistance, a.clickScaleShapeDistance);

    g.context.uniformMatrix3fv(g.u_scale, false, scale_mat);
    a.shapes.filter(shape => shape.isSelected).forEach(shape => {
      switch (shape.type) {
        case cl.cm.line.type:
          shape.start = transformPointByMatrix3(scale_mat, shape.start);
          shape.end = transformPointByMatrix3(scale_mat, shape.end);
          break;
        case cl.cm.rectangle.type:
          shape.p1 = transformPointByMatrix3(scale_mat, shape.p1);
          shape.p2 = transformPointByMatrix3(scale_mat, shape.p2);
          shape.p3 = transformPointByMatrix3(scale_mat, shape.p3);
          shape.p4 = transformPointByMatrix3(scale_mat, shape.p4);
          shape.updateCenter();
          break;
        case cl.cm.circle.type:
          shape.center = transformPointByMatrix3(scale_mat, shape.center);
          // Calculate the new radius based on the scale factor
          let distanceFromCenter = Math.hypot(distX, distY);
          shape.radius = shape.radius * (distanceFromCenter / a.clickScaleBaseDistance);
          break;
        default:

          break;
      }
    });

    a.clickScaleStart1 = null;
    a.clickScaleStart2 = null;
    g.context.uniformMatrix3fv(g.u_scale, false, createIdentityMatrix());
  }
}

function handleEditMousedown(mouse) {
  a.shapes.filter(shape => shape.isSelected).forEach(shape => {
    switch (shape.type) {
      case cl.cm.line.type:
        if (shape.isinGripStart(mouse)) {
          shape.edit = "start";
        } else if (shape.isinGripEnd(mouse)) {
          shape.edit = "end";
        }
        break;
      case cl.cm.rectangle.type:
        if (shape.isinGripP1(mouse)) {
          shape.edit = "p1";
        } else if (shape.isinGripP2(mouse)) {
          shape.edit = "p2";
        } else if (shape.isinGripP3(mouse)) {
          shape.edit = "p3";
        } else if (shape.isinGripP4(mouse)) {
          shape.edit = "p4";
        }
        break;
      case cl.cm.circle.type:
        if (shape.isinGripQ1(mouse)) {
          shape.edit = "q1";
        } else if (shape.isinGripQ2(mouse)) {
          shape.edit = "q2";
        } else if (shape.isinGripQ3(mouse)) {
          shape.edit = "q3";
        } else if (shape.isinGripQ4(mouse)) {
          shape.edit = "q4";
        }
        break;
      default:
        break;
    }
  });
}

function handleMoveRoutePartMousedown() {
  if (!a.clickMoveRouteStart) {

    a.clickMoveRouteStart = { ...a.start };

  } else {
    const move_mat = getMoveMatrix(a.clickMoveRouteStart, a.start);

    let selected: Line[] = (getSelectedShapes().filter((s: Shape) => s instanceof Line) as Line[]);


    // если выбрано больше одной фигуры, то ничего не происходит
    selected.forEach((selectedSeg: Line) => {

      let joinedStart = findConnectedLineStart(selectedSeg, getDisplayedShapes());
      let joinedEnd = findConnectedLineEnd(selectedSeg, getDisplayedShapes());
      let joinedElbows = findConnectedElbows(selectedSeg);

      let pointStart, pointEnd;
      // если отрезок имеет присоединённые отрезки с обоих концов
      if (joinedStart && joinedEnd) {


        ({ pointStart, pointEnd } = getPStartPEndProjWhenJoinedBoth(joinedStart as Line, joinedEnd as Line, move_mat, selectedSeg));

        if (ifjoinedAtStart(joinedStart as Line, selectedSeg)) {
          (joinedStart as Line).start = pointStart;
        } else if (ifjoinedAtEnd(joinedStart as Line, selectedSeg)) {
          (joinedStart as Line).end = pointStart;
        }

        if (ifjoinedAtStart(joinedEnd as Line, selectedSeg)) {
          (joinedEnd as Line).start = pointEnd;
        } else if (ifjoinedAtEnd(joinedEnd as Line, selectedSeg)) {
          (joinedEnd as Line).end = pointEnd;
        }


      }
      // если отрезок имеет присоединённые отрезки только с одного конца
      else {

        if (joinedStart) {

          ({ pointStart, pointEnd } = getPStartPEndProjWhenJoinedStart(joinedStart as Line, selectedSeg, move_mat));


          if (ifjoinedAtStart(joinedStart as Line, selectedSeg)) {
            (joinedStart as Line).start = pointStart;
          } else if (ifjoinedAtEnd(joinedStart as Line, selectedSeg)) {
            (joinedStart as Line).end = pointStart;
          }


        }
        if (joinedEnd) {
          ({ pointStart, pointEnd } = getPStartPEndProjWhenJoinedEnd(joinedEnd as Line, selectedSeg, move_mat));


          if (ifjoinedAtStart(joinedEnd as Line, selectedSeg)) {
            (joinedEnd as Line).start = pointEnd;
          } else if (ifjoinedAtEnd(joinedEnd as Line, selectedSeg)) {
            (joinedEnd as Line).end = pointEnd;
          }


        }

      }



      // если есть присоединённые отводы
      if (joinedElbows.length === 2) {
        joinedElbows.forEach((elb: ElbowBlock) => {
          // взять присоединённые отрезки и передвинуть их концы
          // передвинуть отвод

          transformPointByMatrixDependingOnShapeType(elb, move_mat);

        });
      }
      else if (joinedElbows.length === 1) {
        let elbow = joinedElbows[0];
        transformPointByMatrixDependingOnShapeType(elbow, move_mat);
        // определить, у которого отрезка и на каком конце нет другого elbow
        let openEndBase = elbow.refSegmentBase.segment.whichEndHasNoElbow();
        let openEndSide = elbow.refSegmentSide.segment.whichEndHasNoElbow();

        // TODO
        if (openEndBase) {
          if (openEndBase === 'start') {
            elbow.refSegmentBase.segment.start = transformPointByMatrix3(move_mat, elbow.refSegmentBase.segment.start);
          }
          else if (openEndBase === 'end') {
            elbow.refSegmentBase.segment.end = transformPointByMatrix3(move_mat, elbow.refSegmentBase.segment.end);
          }
        }
        else if (openEndSide) {
          if (openEndSide === 'start') {
            elbow.refSegmentSide.segment.start = transformPointByMatrix3(move_mat, elbow.refSegmentSide.segment.start);
          }
          else if (openEndSide === 'end') {
            elbow.refSegmentSide.segment.end = transformPointByMatrix3(move_mat, elbow.refSegmentSide.segment.end);
          }
        }

      }
      else {
        selectedSeg.start = pointStart;
        selectedSeg.end = pointEnd;

      }

    });

    a.clickMoveRouteStart = null;
  }


}


function handleCalculateNetwork(event) {
  event.preventDefault();
  var mouse = canvasGetMouse(event, g.canvas);
  var mes1 = "Укажите начальный участок с открытым концом";
  var mes2 = "Укажите конечный участок с открытым концом";

  if (getSelectedShapes().length) {
    let selected = getSelectedShapes();
    if (selected.some(s => s.type !== ObjectTypes.line)) {

      return;
    }

    // проверить, все ли участки имеют один и тот же routeId
    if (selected.every(s => getShapeRouteId(s) !== getShapeRouteId(selected[0]))) {

      return;
    }

    // проверить есть ли у выбранного маршрута два открытых конца
    let open1 = selected.find(s => !(s as any).startJ.id || !(s as any).endJ.id);
    let open2 = selected.find(s => (s.id !== open1.id) && (!getShapeStart(s).id || !(s as any).endJ.id));
    if (open1 && open2) {
      // есть два открытых конца
      let routeId = getShapeRouteId(open1);
      let routeSegs = getRoute(routeId);

      let dpSum = routeSegs.reduce((sum, seg) => {
        let net = getShapeNet(seg);
        return sum + getDpRectAir(net.widthMIL, net.heightMIL, net.flowRateCMH, net.realLenMET);
      }, 0);
      let lenSum = routeSegs.reduce((sum, seg) => {
        let net = getShapeNet(seg);
        return sum + net.realLenMET;
      }, 0);

      routeSegs.forEach(s => {
        let net = getShapeNet(s);
        (s as any).velocity = getVelocityRect(net.widthMIL, net.heightMIL, net.flowRateMIL);
        (s as any).dp = getDpRectAir(net.widthMIL, net.heightMIL, net.flowRateMIL, net.realLenMET);
      });


      let resultMessage = `
                    
                    <div>
                        Общая длина <strong>${(lenSum).toFixed(2)}</strong> метров
                    </div>
                    <div>

                    </div>
                    <div>
                        Потери давления <strong>${dpSum.toFixed(2)}</strong> Паскаль
                    </div>
                `;
      clearTooltipAll();
      createInfoTooltip(resultMessage);

      setMode(CommandList.cm.select.type);


    }

  } else {
    if (event.type === "showInitMessage") {
      createInfoTooltip(mes1);
    } else if (event.type === "mousedown") {
      if (!a.clickCalcNetworksStart) {

        if (selectIfMouseInShapeBoundary(mouse)) {

          if (getSelectedShapes().length > 1) {

            return;
          }

          var segStart = getSelectedShapes()[0];

          addShapes([(segStart as any).getOpenEnd()]);
          resetSelectedShapes();
          resetSelectionStep(); // Reset selection step when calculating network
          updateAndDrawShapes();

          clearTooltipAll();
          createInfoTooltip(mes2);

          a.clickCalcNetworksStart = true;
        }
        ;

      } else {

        if (selectIfMouseInShapeBoundary(mouse)) {


          if (getSelectedShapes().length > 1) {

            return;
          }

          var segEnd = getSelectedShapes()[0];

          addShapes([(segEnd as any).getOpenEnd()]);
          resetSelectedShapes();
          resetSelectionStep(); // Reset selection step when calculating network
          updateAndDrawShapes();

          // --- calc
          let routeId = getShapeRouteId(segEnd);
          let routeSegs = getRoute(routeId);

          //// --- test for remove

          let width = getShapeNet(a.line).widthMil;
          let height = getShapeNet(a.line).heightMil;
          let flowRate = getShapeNet(a.line).flowRateCmh;
          let velocity = getVelocityRect(width, height, flowRate);

          routeSegs.forEach(s => {
            let net = getShapeNet(s);
            net.widthMIL = width;
            net.heightMIL = height;
            net.flowRateCMH = flowRate;
            net.velocity = velocity;
          });
          let lensum = routeSegs.reduce((sum, seg) => sum + getShapeNet(seg).realLenMET, 0);
          let dp = getDpRectAir(width, height, flowRate, lensum);

          let result = `
                        <div>
                            Размер <strong>${width}x${height}</strong> мм
                        </div>
                        <div>
                            Расход <strong>${flowRate}</strong> м³/ч
                        </div>
                        <div>
                            Скорость <strong>${velocity.toFixed(2)}</strong> м/с
                        </div>
                        <div>
                            Общая длина <strong>${(lensum).toFixed(2)}</strong> метров
                        </div>
                        <div>
    
                        </div>
                        <div>
                            Потери давления <strong>${dp.toFixed(2)}</strong> Паскаль
                        </div>
                    `;
          clearTooltipAll();
          createInfoTooltip(result);
          //// --- test for remove

          // --- calc


          setMode(CommandList.cm.select.type);
          // clearTooltipAll();

          a.clickCalcNetworksStart = false;
        }
        ;

      }
    }

  }
}

/**
 * Похоже первое моё сознательное использование замыкания :)
 * Оказывается это удобно - можно скрыть переменные из глобальной области видимости.
 * А анонимная функция просто вызывается сразу же каждый раз при вызове внешней функции.
 * При этом переменные netInfo... запоминаются этой анонимной функцией.
 */
function handleCallNetworkInfoWindow() {
  var netInfoShowNetworkInfoWindow;
  var netInfoCalledWithShortcut;

  a.commandsUI.callNetworkInfoWindow$.subscribe((v) => {
    netInfoShowNetworkInfoWindow = v.show;
    netInfoCalledWithShortcut = v.calledWithShortcut;
  });

  (function () {
    var show = !netInfoShowNetworkInfoWindow;
    var calledWithShortcut = !netInfoCalledWithShortcut;
    a.commandsUI.callNetworkInfoWindow$.next({
      show: show,
      calledWithShortcut: calledWithShortcut
    });
    setMode(CommandList.cm.select.type);
  })();
}

function handleFocusFlowRateInput() {
  // Show the network info window and focus on flow rate input
  (function () {
    var show = true; // Always show the window
    var calledWithShortcut = true; // Indicate it was called with shortcut
    
    // Trigger the focusFlowRateInput command
    a.commandsUI.focusFlowRateInput$.next({
      show: show,
      calledWithShortcut: calledWithShortcut
    });
    
    // Also show the network info window
    a.commandsUI.callNetworkInfoWindow$.next({
      show: show,
      calledWithShortcut: false // Don't trigger general focus
    });
    
    setMode(CommandList.cm.select.type);
  })();
}

function handleKeyboard() {

}

/**
 * Функция собирает блок из выбранных фигур
 */
function handleMakeBlock() {
  var arrayOfSelectedShapes = getSelectedShapes();
  if (!arrayOfSelectedShapes.length) {
    let message = "Не выбрано ни одной фигуры";

    a.showAlertDialog$.next({
      title: "Ошибка",
      message: `${message}`,
      isVisible: true
    });
    return;
  }

  var free = new Block(arrayOfSelectedShapes, s.blockColor, s.blockThickness);
  free.isSelected = false;

  var ids = arrayOfSelectedShapes.map(s => s.id);
  var exclude = getashapes().filter(s => !ids.includes(s.id));
  setashapes(exclude);
  addShapes(free);
  updateAndDrawShapes();
  setMode(cl.cm.select.type);
}

/**
 * Функция запускает операцию создания точек подключения для блоков
 *
 */


function handleAssignConnectionPoints(event) {

  if (!getSelectedShapes().length) {
    let message = "Не выбрана фигура";

    a.showAlertDialog$.next({
      title: "Ошибка",
      message: `${message}`,
      isVisible: true
    });
    setMode(cl.cm.select.type);
    return;
  }
  if (getSelectedShapes().length > 1) {
    let message = "Выбрано больше одной фигуры";

    a.showAlertDialog$.next({
      title: "Ошибка",
      message: `${message}`,
      isVisible: true
    });
    setMode(cl.cm.select.type);
    return;
  }
  if (getSelectedShapes()[0].type !== ObjectTypes.block) {
    let message = "Выбранная фигура не является блоком. Точки присоединения можно указывать только у блоков.";

    a.showAlertDialog$.next({
      title: "Ошибка",
      message: `${message}`,
      isVisible: true
    });
    setMode(cl.cm.select.type);
    return;
  }

  /**
   * Сочетание клавиш или нажатие на кнопку с инонкой просто активирует режим 'assign-connection-points', при этом
   * позиция мыши не указана. Действительное выполнение дальнейших действий происходит из модуля down.js,
   * поэтому если событие не определено или является событием нажатия клавиш, происходит возврат из функции
   */

  a.showAlertDialog$.next({
    title: "Внимание",
    message: "Укажите первую точку присоединения.",
    isVisible: true
  });

  if (event instanceof KeyboardEvent || !event) return;


  var fn = (e) => {
    if (e.key === "Enter") {
      document.removeEventListener("keydown", fn);
      setMode(cl.cm.select.type);
      return;
    }
  };


  addToCurrentListeners(document, "keydown", fn);

  var assignCpoint = (point) => {

    var free = getSelectedShapes()[0];
    var cPoints = (free as any).getCpoints();

    var size = Object.values(cPoints).length;

    if (size === 2) {
      let message = "Блок уже имеет две точки присоединения";

      a.showAlertDialog$.next({
        title: "Ошибка",
        message: `${message}`,
        isVisible: true
      });

      return;
    }

    (free as any).assignConnectionPoint(point);
    updateAndDrawShapes();


    if (size === 0) {
      a.showAlertDialog$.next({
        title: "Внимание",
        message: "При необходимости укажите вторую точку присоединения.",
        isVisible: true
      });
    } else if (size === 1) {
      a.showAlertDialog$.next({
        title: "Внимание",
        message: "Указание точек присоединение завершено. Для продолжения работы нажмите Escape.",
        isVisible: true
      });
    }

  };

  assignCpoint(a.start);


  // завершить операцию
}

/**
 * Функция разрывает линию при вставке арматуры труб или воздуховодов
 */
function breakPipe(mouse: Point, block: Block) {


  /**
   * TODO: компенсация длины - добавлять в блок
   */

  if (block) {

    let { cp1, cp2 } = block.getCpoints();

    // если точка присоединения только одна, то разрыв линии не требуется
    if (!cp2) return;

    getDisplayedShapes().filter((s: Line) => s.type === ObjectTypes.line).forEach((s: Line) => {
      if (s.isinSelectBoundary(mouse)) {

        /**
         * Угол линии определяется при помощи skew,
         * skew неоднозначен только если он близок к нулю
         * (то есть может быть немного больше или немного меньше нуля),
         * близок к нулю он только у горизонтальных линий.
         * Функция transformPointByMatrixDependingOnShapeType помимо самой фигуры free
         * также трансформирует её точки присоединения cpoints.
         * Точки трансформируются при помощи матрицы поворота,
         * и конечно координаты производных точек немного не совпадают
         * с координатами отрезка, на который устанавливается элемент.
         * Поэтому для горизонтальных (для вертикальных ? ) линий
         * нужно скорректировать координату "y" cpoints
         */

        // TODO: здесь отвод-elbow должен перемещаться вместе с точкой новой линии

        if (isLineHorizontal(s)) {
          // скорректировать координаты cpoints
          cp1.y = s.start.y;
          cp2.y = s.start.y;
        }

        let newLine1: Line = s.getClone();
        let newLine2: Line = s.getClone();

        if ((s.start.x < s.end.x && cp1.x < cp2.x) || (s.start.x > s.end.x && cp1.x > cp2.x)) {
          newLine1.start = s.start;
          newLine1.end = cp1;
          newLine2.start = cp2;
          newLine2.end = s.end;

        } else if ((s.start.x < s.end.x && cp1.x > cp2.x) || (s.start.x > s.end.x && cp1.x < cp2.x)) {
          newLine1.start = s.start;
          newLine1.end = cp2;
          newLine2.start = cp1;
          newLine2.end = s.end;

        } else {
          if ((s.start.y < s.end.y && cp1.y < cp2.y) || (s.start.y > s.end.y && cp1.y > cp2.y)) {
            newLine1.start = s.start;
            newLine1.end = cp1;
            newLine2.start = cp2;
            newLine2.end = s.end;


          } else if ((s.start.y < s.end.y && cp1.y > cp2.y) || (s.start.y > s.end.y && cp1.y > cp2.y)) {
            newLine1.start = s.start;
            newLine1.end = cp2;
            newLine2.start = cp1;
            newLine2.end = s.end;


          }
        }

        addShapes(newLine1);
        addShapes(newLine2);
        deleteOneShape(s);

      }
    });

    updateAndDrawShapes();
  }

}

/**
 * Функция восстанавливает трубу при убирании элемента трубопровода
 */
export function restorePipe(free) {

  var cSegs = free.getConnectedSegments();
  var seg1 = arrayFirst(cSegs);
  var seg2 = arrayLast(cSegs);

  if (!seg1 && !seg2) return;

  var endPoints = findMaxMinPoints(seg1, seg2);

  seg1.start = endPoints.min;
  seg1.end = endPoints.max;

  deleteOneShape(seg2);
}

/**
 * Функция перемещает концы отрезка вместе с блоком,
 * если у блока есть точки присоединения
 */
function movePipe(free, moveMat, cSegs, cPoints) {

  var connectedSegmentsPoints = free.getConnectedSegmentsPoints(cSegs, cPoints);
  var seg1 = arrayFirst(cSegs);
  var seg2 = arrayLast(cSegs);
  var cp1 = free.getCpoints().cp1;
  var cp2 = free.getCpoints().cp2;

  for (const key in connectedSegmentsPoints) {
    if (Object.prototype.hasOwnProperty.call(connectedSegmentsPoints, key)) {
      const result = connectedSegmentsPoints[key];

      if (result.name === "seg1Start") {
        if (result.cpoint === "cp1") {
          seg1.start = cp1;
        } else if (result.cpoint === "cp2") {
          seg1.start = cp2;
        }
      }
      if (result.name === "seg1End") {
        if (result.cpoint === "cp1") {
          seg1.end = cp1;
        } else if (result.cpoint === "cp2") {
          seg1.end = cp2;
        }
      }
      if (result.name === "seg2Start") {
        if (result.cpoint === "cp1") {
          seg2.start = cp1;
        } else if (result.cpoint === "cp2") {
          seg2.start = cp2;
        }
      }
      if (result.name === "seg2End") {
        if (result.cpoint === "cp1") {
          seg2.end = cp1;
        } else if (result.cpoint === "cp2") {
          seg2.end = cp2;
        }
      }
    }
  }

  if (connectedSegmentsPoints) {
    return true;
  }
  return false;

}


/**
 * Функция проверяет, соединены ли отрезки, передаваемые в аргументе, с блоком, и если соединены скрывает точки присоединения
 * @param block блок, у которого нужно изменить отображение точек присоединения (голубые окружности с крестиком)
 * @param segments отрезки, которые нужно проверить на соединение с этим блоком
 */
export function checkConnections(block: (Block | ElbowBlock), segments: Line[]) {

  var cp1 = block.getCps().cp1 ?? null;
  var cp2 = block.getCps().cp2 ?? null;


  if (cp1) {
    cp1.isDisplayed = true;
  }
  if (cp2) {
    cp2.isDisplayed = true;
  }

  var netIds = [];


  segments.forEach((segment: Line) => {
    const isConnectedToCp1 = isin(segment.start, cp1?.point) || isin(segment.end, cp1?.point);
    const isConnectedToCp2 = isin(segment.start, cp2?.point) || isin(segment.end, cp2?.point);

    if (isConnectedToCp1 && cp1) {
      cp1.isDisplayed = false;
      netIds.push(segment.netId);
    } else if (isConnectedToCp2 && cp2) {
      cp2.isDisplayed = false;
      netIds.push(segment.netId);
    }
  });
  /**
   * если все routeId в массиве одинаковые, то всё происходит как ожидалось -
   * блок присоединён к отрезкам одного и того же маршрута. Если же разные - это
   * не ожидаемое поведение и блоку routeId не назначается
   */

  if (netIds.every(id => id === netIds[0])) {
    block.netId = netIds[0];
  }

  a.updateCalculations$.next(true);

}

/**
 * Функция отображает окно поиска блоков
 */

export function handleShowBlockSearch() {
  a.showBlockSearch$.next(true);
}

/**
 * Функция скрывает окно поиска блоков
 */
export function handleHideBlockSearch() {
  a.showBlockSearch$.next(false);
}

/**
 * Функция добавляет созданную фигуру в коллекцию блоков
 */
export function handleSaveToBlockCollection() {

  if (!getSelectedShapes().length) {
    let message = "Не выбрана фигура для сохранения в коллекцию";

    a.showAlertDialog$.next({
      title: "Ошибка",
      message: message,
      isVisible: true
    });
    return;
  }

  // отображаем окно ввода названия блока
  a.showInputBlockCollectionDialog$.next({
    title: "Сохранение блока в коллекцию",
    message: "Введите данные блока:",
    isVisible: true
  });

  var block: Block;
  // подписываемся на событие ввода названия блока и сохранения его в коллекции
  a.addToBlockCollection$.subscribe(v => {

    var free = getSelectedShapes().filter(s => s.type === ObjectTypes.block) as Block[];

    if (!free || !free.length) return;

    if (free.length > 1) {

      return;
    }

    block = free[0];

    block.data = v;
    block.initNetInfo();

    block.zlc = a.zlc;
    saveToBlockCollection(block);

  });

  // подписываемся на событие обновления базы данных
  dbUpdate$.subscribe(v => {
    if (v) {
      deleteOneShape(block);
      updateAndDrawShapes();
      setMode(cl.cm.select.type);

      a.showAlertDialog$.next(
        {
          title: "Информация",
          message: `Блок "${block.data.code}" успешно добавлен в коллекцию`,
          isVisible: true
        }
      );
      a.showInputBlockCollectionDialog$.next({
        isVisible: false
      });

    } else {
      a.showAlertDialog$.next(
        {
          title: "Ошибка",
          message: "Ошибка при добавлении блока в коллекцию",
          isVisible: true
        }
      );
    }
  });
}

/**
 * Вспомогательная функция, обновляет позиции текста
 */

function updateTextPositions(textLinesCollection, clickStart, aStart) {
  textLinesCollection.filter(t => t.selected).forEach(text => {
    const deltaX = clickStart.x - aStart.x;
    const deltaY = clickStart.y - aStart.y;
    text.start.x = text.moveXclick - deltaX;
    text.start.y = text.moveYclick - deltaY;
    text.edit = null;
  });

  cnv.clear();
  rerender();

}






/**
 * Функция разбивает переданную линию на две в точке.
 * Возвращает массив новых отрезков
 * @param {Line} segment - отрезок, который нужно разбить
 * @param {Point} point - точка разбиения
 * @return {Line[]}
 */

export function breakSegmentForTee(segment, point) {
  var seg1 = segment.getClone();
  var seg2 = segment.getClone();
  // начало и конец линии должны остаться на местах.
  var start = segment.start;
  var end = segment.end;

  seg1.start = start;
  seg1.end = point;

  seg2.end = end;
  seg2.start = point;

  return [seg1, seg2];
}

export {
  handleMakeOffset,
  handleMakeOffsetGuide,
  handleSelectAll,
  handleCalculateNetwork,
  handleJoin,
  handleCallNetworkInfoWindow,
  handleFocusFlowRateInput,
  handleRemoveGuides,
  handleCreateTheSame,
  handleHide,
  handleDisplayAll,
  handleSelect,
  handleEscape,
  handleDelete,
  handleSaveShapesToDatabase,
  handleStampClick,
  handleKeyboard,
  handleLine,
  handleRectangle,
  handleSquare,
  handleCircle,
  handleMoveMousedown,
  handleCopyMousedown,
  handleRotateMousedown,
  handleRotateAndCopyMousedown,
  handleScaleMousedown,
  handleMirrorMousedown,
  handleEditMousedown,
  handleMoveRoutePartMousedown,
  handleMakeBlock,
  handleAssignConnectionPoints
};

